import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import DatePickerField from '@/domain/termine/components/DatePicker/DatePickerField';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';
import { DatePickerFieldName } from '@/domain/termine/shared/types/datePicker';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import dayjs, { Dayjs } from 'dayjs';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function DatePickerFormField({
  form,
  name,
}: {
  form: UseFormReturn<FormValues>;
  name: DatePickerFieldName;
}) {
  const { t } = useTranslation();

  const dateValue = (
    name: DatePickerFieldName,
    fieldValue?: string | Dayjs,
  ): Dayjs | undefined =>
    fieldValue ? dayjs(fieldValue) : name === 'datum' ? dayjs() : undefined;

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex-1">
          <FormLabel>
            {name === 'datum' ? (
              <>{t(`domain.termine.sheet.fields.am`)}</>
            ) : (
              t('domain.termine.sheet.fields.laufzeitBis')
            )}
          </FormLabel>

          <DatePickerField
            {...field}
            onChange={field.onChange}
            icon={faCalendar}
            onSelect={(d) => field.onChange(d)}
            date={dateValue(name, field.value)}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
